const MODULE_NAME = "ICD10";
const ICD10_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const ICD10_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  ICD10_FETCH_STARTED,
  ICD10_FETCH_COMPLETED
};
